/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { 
  styled,
  Typography,
  TextField,
  OutlinedInput,
  Button,
} from "@mui/material";

export const LoginFormContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
})

export const LoginFormWrapper = styled('div')({
  '@media (max-width: 460px)': {
    width: '350px !important',
  },
  width: '400px',
  boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px'
})

export const StyledTitle = styled(Typography)({
  textAlign: 'center',
  fontSize: '38px',
  fontWeight: '600',
  marginTop: '40px'
})

export const StyledSubTitle = styled(Typography)({
  textAlign: 'center',
  fontSize: '24px',
  color: '#2d333a',
  marginTop: '-4px',
})

export const StyledDescription = styled(Typography)({
  fontSize: '16px',
  color: '#2d333a',
  textAlign: 'center',
  marginTop: '5px',
  padding: '0px 20px',
})

export const StyledEmailField = styled(TextField)({
  '@media (max-width: 460px)': {
    width: '320px !important',
  },
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '2px solid #395bbd !important'
    },
  },
  width: '330px'
})

export const StyledPasswordField = styled(OutlinedInput)({
  '@media (max-width: 460px)': {
    width: '320px !important',
  },
  '&:hover': {
    "& .MuiOutlinedInput-notchedOutline": {
      border: '2px solid #395bbd !important'
    },
  },
  width: '330px',
  marginTop: '-20px',
})

export const StyledForgotPasswordLink = styled('a')({
  '&:hover':{
    color: '#001b59'
  },
  textDecoration: 'none',
  color: '#395bbd',
  fontWeight: "600",
  fontSize: '15px',
  cursor: 'pointer',
})

export const StyledFormContainer = styled('form')({
  display: 'flex',
  gap: '30px',
  alignItems: 'center',
  marginTop: '20px',
  flexDirection: 'column',
})

export const StyledContinueButton = styled(Button)({
  '@media (max-width: 460px)': {
    width: '320px !important',
  },
  '&:hover': {
    backgroundColor: '#001b59',
  },
  '&.Mui-disabled': {
    backgroundColor: '#001b59',
  },
  width: '330px',
  textTransform: 'none',
  fontSize: '16px',
  backgroundColor: '#395bbd',
  boxShadow: 'none',
  height: '52px',
  marginTop: '-10px',
  marginBottom: '30px',
  fontWeight: '400',
})

export const StyledHelperText = styled('div')({
  color: '#d32f2f',
  fontSize: '0.75rem',
  paddingTop: '5px',
  letterSpacing: "0.3px",
  marginLeft: '12px',
})

export const ForgotPasswordContainer = styled('div')({
  '@media (max-width: 460px)': {
    width: '320px !important',
  },
  width: '330px',
  marginTop: '-20px',
})

export const CarouselContainer = styled('div')({
  '@media (max-width: 1100px)': {
    display: 'none',
  },
  height: '100vh',
  width: '60%',
})

export const FormContainer = styled('div')({
  '@media (max-width: 1000px)': {
    width: '400px !important',
  },
  height: '100%',
  width: '40%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const logoContainerStyle = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '20px',
};
